<template>
    <div class="asdan-background">
        <header>
            <el-row type="flex" justify="center">
                <el-col :span="22">
                    <div class="grid-content">
                        <router-link to="/">
                            <img src="https://seed-static.seedasdan.com/wordpress/2024/09/aseeder-logo-new.png?x-oss-process=image/resize,m_fill,w_160,h_48"/>
                        </router-link>
                    </div>
                </el-col>
            </el-row>
            <img class="asdan-background-image" src="../assets/background.jpg"/>
            <div class="asdan-background-mask"></div>
        </header>
        <div class="content">
            <div class="asdan-login">
                <div class="panel-title"><h5 class="pb-5 pl-10">Log In</h5></div>
                <div class="panel-body pl-20 pr-20">
                    <el-form :model="logform" :rules="rules" ref="logform">
                        <el-form-item prop="username">
                            <el-input v-model="logform.username" :maxlength="Emaxlength" placeholder="Email Address"
                                      class="pt-20" @keyup.enter.native="submitForm('logform')" name="email" auto-complete="on"></el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input v-model="logform.password" :maxlength="Pmaxlength" placeholder="Password"
                                      type="password" @keyup.enter.native="submitForm('logform')"></el-input>
                            <!--<div class="el-input">&lt;!&ndash;键盘事件只能绑定在button 上，故将el－input拆分&ndash;&gt;
                                <input class="el-input__inner" v-model="logform.password" :maxlength="Pmaxlength" placeholder="Password"
                                       type="password" v-on:keyup.enter="submitForm('logform')"/>
                            </div>-->
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="submitForm('logform')">Log In to ASDAN</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import md5 from '../component/md5'
    export default {
        data() {
            return {
                activeIndex2: '1',
                input: '',
                Emaxlength: 255,
                Pmaxlength: 20,

                logform: {
                    username: '',
                    password: ''
                },
                rules: {
                    username: [
                        {required: true, message: 'Email address is required', trigger: 'blur'},
                        {type: 'email', message: 'Invalid email address', trigger: 'blur'},
                    ],
                    password: [
                        {required: true, message: 'Password is required', trigger: 'blur'},
                    ]
                }
            }
        },
        methods: {
            //前端验证并跳转
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var passward_md5 = md5.hex_md5(this.logform.password);
                        this.$http.post('user/login', {}, {
                            params: {
                                username: this.logform.username,
                                password: passward_md5
                            }
                        }).then(response => {
                            switch (response) {
                                case 'admin':
                                    this.$router.push('/admin/student')
                                    break
                                case 'teacher':
                                    this.$router.push('/teacher/progress')
                                    break
                                case 'ta':
                                    this.$router.push('/ta/progress')
                                    break
                                case 'student':
                                    this.$router.push('/student/cope')
                                    break
                            }
                        }).catch(error => {
                            this.$message.error(error.message)
                        })
                    } else {
                        return false;
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../css/variable';

    @media screen and (min-width: 768px) {
        .content {
            width: 500px;
            position: absolute;
            left: 50%;
            margin-left: -250px;
        }
    }

    /* 设置了浏览器宽度大于1000px时 显示700px宽度 */
    header {
        padding-top: 12px;
        height: 48px;
        background: $white;
        overflow: hidden;
        img {
            width: 160px;
            padding: 0 !important;
        }
        .app {
            margin-right: 0 !important;
        }
    }

    .asdan-background {
        .asdan-background-image {
            position: fixed;
            top: 0;
            left: 0;
            min-width: 100%;
            min-height: 100%;
            z-index: -1000;
        }
        .asdan-background-mask {
            position: fixed;
            top: 0;
            left: 0;
            min-width: 100%;
            min-height: 100%;
            z-index: -900;
            background-color: rgba(#fff, 0.9);
        }
    }

    .content {
        .asdan-login {
            margin-left: auto;
            margin-right: auto;
            margin-top: 20%;
            margin-bottom: 30%;
            background: $theme-color;
            height: 260px;
            border-radius: 10px;
            border: 2px solid $theme-color;
            -moz-box-sizing: border-box; /*Firefox3.5+*/
            -webkit-box-sizing: border-box; /*Safari3.2+*/
            -o-box-sizing: border-box; /*Opera9.6*/
            -ms-box-sizing: border-box; /*IE8*/
            box-sizing: border-box; /*W3C标准(IE9+，Safari5.1+,Chrome10.0+,Opera10.6+都符合box-sizing的w3c标准语法)*/
            span.label {
                display: block;
                text-align: left;
            }
            .panel-title {
                font-size: 18px;
                line-height: 36px;
                color: $white;
            }
            .panel-body {
                background: $white;
                height: 215px;
                border-bottom-left-radius: 10px;
                border-bottom-right-radius: 10px;
                .dialog-footer {
                    button {
                        width: 100%;
                    }
                }
            }
        }
    }

    .el-input {
        max-width: none;
    }
</style>


// WEBPACK FOOTER //
// Login.vue?6931887d